import * as React from 'react';
import { Box } from '@cloudflare/component-box';

export const E2EManagerPage = (): JSX.Element => (
  <Box padding="1em">
    <h1>E2E Manager</h1>
  </Box>
);
